export default __webpack_public_path__ + "assets/images/b541f825229d9c2727fcf1cce462b6c9.mp3";